// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"31c677a6","464":"5abdf5ef","787":"aba45fdb","841":"623ddb48","986":"3017f387"}[chunkId] + ".chunk.js";
};